import api from "../../config/client.axios.api";

export const deleteTypeTransactionApi = async (id: any) => {
  const response = await api.delete(`/type-transaction?typeId=${id?.id}`);
  return response.data;
};
